import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-garage',
  templateUrl: './icon-garage.component.html',
  styleUrls: ['./icon-garage.component.scss']
})
export class IconGarageComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
